import { Navigate, useParams } from "react-router-dom";

const EditSubscriptionPlan = () => {
  const { id } = useParams();

  if (id) {
    return <Navigate to={`/manage-subscription/edit/${id}`} replace />;
  }

  return <Navigate to="/manage-subscription" replace />;
};

export default EditSubscriptionPlan;
